import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns company style from page state
 */
export default function useCompanyStyle() {
    return useAppSelector((state) => state?.page.companyStore.style)
}